import Script from "next/script";

export const PRE_AUTH_TAG = "GTM-TJGLRD9";
export const POST_AUTH_TAG = "GTM-N745T8T";

const GoogleTagManagerScript = ({ tag = POST_AUTH_TAG }) => {
  return (
    <Script id="google-tag-manager">
      {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${tag}');`}
    </Script>
  );
};

export default GoogleTagManagerScript;
